import type { ITaskSheetInput, ITaskSheetSection } from '@/interfaces'
import TaskSheetInput from './TaskSheetInput'

class TaskSheetSection implements ITaskSheetSection {
  title: string

  description: string

  inputs: ITaskSheetInput[]

  constructor(taskSheetSection?: any, isGetRequest?: boolean) {
    this.title = taskSheetSection?.title ?? ''
    this.description = taskSheetSection?.description ?? ''
    this.inputs =
      taskSheetSection?.inputs?.map((input: any) => new TaskSheetInput(input, isGetRequest)) ?? []
  }
}

export default TaskSheetSection
